import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/query/react';
import { useInjectReducer } from 'utils/redux-injectors';
import { State } from './types';
import { endpoints, baseQuery } from 'utils/api/endpoints';

export const initialState: State = {};

const slice = createSlice({
  name: 'requestFile',
  initialState,
  reducers: {},
});

export const api = createApi({
  reducerPath: 'requestFileApi',
  baseQuery,
  tagTypes: ['Request-file'],
  endpoints: builder => ({
    getList: builder.query({
      query: (params: { page?: number; limit?: number } = {}) => ({
        url: `${endpoints.REQUEST_FILE}?page=${params.page || 1}&limit=${
          params.limit || 20
        }`,
        method: 'GET',
      }),
    }),
  }),
});

export const { actions: requestFileAction } = slice;

export const useRequestFileSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  useInjectReducer({ key: api.reducerPath, reducer: api.reducer });
  return {
    actions: requestFileAction,
    useGetListQuery: api.useLazyGetListQuery,
  };
};
